import orange from '@material-ui/core/colors/orange';
import purple from '@material-ui/core/colors/purple';
import blue from '@material-ui/core/colors/blue';

const styles = theme => ({
    categoryActive: {
        color: blue[500]
    },
    competenceActive: {
        color: orange[500]
    },
    expiryPanel: {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `solid 1px ${theme.palette.common.border}`,
        margin: 0,
        width: '100%'
    },
    disabled: {
        opacity: 0.7
    },
    expiryIcon: {
        color: theme.palette.text.disabled,
        margin: theme.spacing(1)
    },
    expiryActive: {
        color: purple[500],
    },
    expiryDateLabel: {
        marginLeft: theme.spacing(1),
    }
});

export default styles;